var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.stepComponent,{key:"0",tag:"Component",on:{"setStep":_vm.setStep}}),(_vm.iconComponent)?_c(_vm.iconComponent,{key:"1",tag:"Component",staticClass:"questionnaire__substrate-img"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }